import api from '../core/api';

export interface PlatformServiceMenuItem {
  label: string;
  path: string;
  icon: string;
  sortOrder: number;
  requiredFeature?: string;
  requiredPermission?: string;
}

export interface PlatformServiceDef {
  code: string;
  name: string;
  description?: string;
  category: string;
  icon: string;
  image?: string;
  primaryColor: string;
  secondaryColor: string;
  serviceType: 'business' | 'platform';
  status: 'draft' | 'active' | 'deprecated';
  supportedCountries: string[];
  countryRequired: boolean;
  stateRequired: boolean;
  cityRequired: boolean;
  masterGroupKeys: string[];
  menuItems: PlatformServiceMenuItem[];
  mobileMenuItems: PlatformServiceMenuItem[];
  defaultPermissions: string[];
  settingCategories: string[];
  featureKeys: string[];
  subServiceTemplates: { name: string; slug: string; description?: string; defaultPricing?: Record<string, unknown> }[];
  sortOrder: number;
  isSystem: boolean;
}

export interface ServiceCategory {
  code: string;
  name: string;
  description?: string;
  icon: string;
  sortOrder: number;
}

export interface ServiceCatalogResponse {
  services: PlatformServiceDef[];
  mainNav: PlatformServiceMenuItem[];
  configNav: (PlatformServiceMenuItem & { superAdminOnly?: boolean; requiredFeature?: string })[];
}

export async function getPlatformServices(params?: { status?: string; category?: string }) {
  const res = await api.get('/platform/services', { params });
  return res.data.data as PlatformServiceDef[];
}

export async function getPlatformService(code: string) {
  const res = await api.get(`/platform/services/${code}`);
  return res.data.data as PlatformServiceDef;
}

export async function getServiceCatalog() {
  const res = await api.get('/platform/services/catalog');
  return res.data.data as ServiceCatalogResponse;
}

export async function getServiceCategories() {
  const res = await api.get('/platform/services/categories');
  return res.data.data as ServiceCategory[];
}

export async function createPlatformService(payload: Partial<PlatformServiceDef>) {
  const res = await api.post('/platform/services', payload);
  return res.data.data as PlatformServiceDef;
}

export async function updatePlatformService(code: string, payload: Partial<PlatformServiceDef>) {
  const res = await api.put(`/platform/services/${code}`, payload);
  return res.data.data as PlatformServiceDef;
}

export async function deletePlatformService(code: string) {
  const res = await api.delete(`/platform/services/${code}`);
  return res.data.data as PlatformServiceDef;
}
